"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetPageCalendarModuleLayouts = void 0;
exports.SetPageCalendarModuleLayouts = [
    "list-view",
    "card-swiper",
];
//# sourceMappingURL=Calendar.js.map